import AuthButtonContainer from './AuthButtonContainer';
import { IStoreState } from '../../../modules';
import OobPhoneChallengeRequest from '../challenge-request/OobPhoneChallengeRequest';
import { connect } from 'react-redux';
import { faPhoneVolume } from '@fortawesome/free-solid-svg-icons';

class OobPhoneAuthButton extends AuthButtonContainer<Props, {}> {
  static icon = faPhoneVolume
  static authname = "OOB Phone"
  static description = "Receive a phone call and enter a token"
  static authLevel = 850

  static challengeRequestComponent = OobPhoneChallengeRequest

  get enrolled(): boolean {
    return this.props.authmethods.oobPhone.enrolled
  }

  get required(): boolean {
    return this.props.challenge.requiredCredentials.oobPhone ? true : false
  }
}

const mapStateToProps = ({ authmethods, challenge }: IStoreState) => ({
  authmethods,
  challenge,
})

interface Props extends ReturnType<typeof mapStateToProps> {
}

export default connect(mapStateToProps)(OobPhoneAuthButton)